import { render, staticRenderFns } from "./QuotationPriceHistoryAdd.vue?vue&type=template&id=546d2055&"
import script from "./QuotationPriceHistoryAdd.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistoryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports